import { For, RadioGroup, Text, VStack } from '@chakra-ui/react';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectActiveUser } from '@redux/authent/authent.selectors';
import { selectDisplayMode } from '@redux/settings/settings.selectors';
import { usePatchDisplayModeMutation } from '@services/config/setting.api';
import { FormattedMessage } from 'react-intl';

import { DisplayModeEnum } from '@/types/authent/login.types';

export default function DisplayModeSetting() {
  const { login } = useAppSelector(selectActiveUser);
  const displayMode = useAppSelector(selectDisplayMode);
  const displayModeOptions = Object.values(DisplayModeEnum).filter((value) => value !== DisplayModeEnum.NOT_SET);

  const [patchDisplayMode] = usePatchDisplayModeMutation();

  const handleDisplayModeChange = (displayMode: string) => {
    patchDisplayMode({
      login,
      displayMode: displayMode as DisplayModeEnum,
    });
  };

  return (
    <VStack backgroundColor="neutral.800" flexShrink={0} gap={4} padding={4} alignItems="start" height="100%">
      <Text fontSize="22px">
        <FormattedMessage id="components.userSettings.displayMode.title" />
      </Text>
      <RadioGroup.Root
        data-group
        disabled
        value={displayMode}
        onValueChange={({ value }) => handleDisplayModeChange(value ?? DisplayModeEnum.MULTI_TABS_WITH_COCKPIT)}
      >
        <For each={displayModeOptions}>
          {(item) => (
            <RadioGroup.Item key={item} value={item}>
              <RadioGroup.ItemIndicator />
              <RadioGroup.ItemHiddenInput />
              <RadioGroup.ItemText>
                <FormattedMessage id={`components.userSettings.displayMode.${item}`} />
              </RadioGroup.ItemText>
            </RadioGroup.Item>
          )}
        </For>
      </RadioGroup.Root>
    </VStack>
  );
}
